import { render, staticRenderFns } from "./IncidentReport.vue?vue&type=template&id=3054bbb6&scoped=true"
import script from "./IncidentReport.vue?vue&type=script&lang=js"
export * from "./IncidentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3054bbb6",
  null
  
)

export default component.exports